/**
 * MonthlyChartsView - Visualização de gráficos mensais do calendário
 * 
 * Extraído do App.js durante refatoração Fase 1
 * 
 * Funcionalidades:
 * - Exibição de produção mensal
 * - Resumo de atividades (sangria, reposição, chuva)
 * - Barras de progresso visuais
 * 
 * Dependências:
 * - useTranslation (traduções)
 */

import React from "react";
import { useTranslation } from "../translations";

const MonthlyChartsView = ({ summary, month }) => {
  const { t } = useTranslation();
  if (!summary) return null;

  const monthName = (() => {
    const [year, monthNum] = month.split('-');
    const monthKeys = ['rptMonthJan','rptMonthFeb','rptMonthMar','rptMonthApr','rptMonthMay','rptMonthJun','rptMonthJul','rptMonthAug','rptMonthSep','rptMonthOct','rptMonthNov','rptMonthDec'];
    return t(monthKeys[parseInt(monthNum) - 1]);
  })();
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
      {/* Production Chart */}
      <div className="hevea-chart-container">
        <h3 className="text-lg font-semibold mb-4" style={{color: 'var(--hevea-green)'}}>
          📦 {t('mchProduction')} - {monthName}
        </h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">{t('mchTotalProduced')}</span>
            <span className="text-xl font-bold" style={{color: 'var(--hevea-production)'}}>
              {summary.summary.total_producao_kg} kg
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3">
            <div 
              className="bg-gradient-to-r from-green-400 to-green-600 h-3 rounded-full transition-all duration-500"
              style={{width: `${Math.min((summary.summary.total_producao_kg / 500) * 100, 100)}%`}}
            ></div>
          </div>
          <div className="text-xs text-gray-500">
            {t('mchMonthlyGoal')}
          </div>
        </div>
      </div>

      {/* Activities Chart */}
      <div className="hevea-chart-container">
        <h3 className="text-lg font-semibold mb-4" style={{color: 'var(--hevea-green)'}}>
          🎯 {t('mchActivities')} - {monthName}
        </h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600 flex items-center gap-2">
              <img src="/icons/faca_sangria.png" alt="" className="w-4 h-4" /> {t('mchBleedingDays')}
            </span>
            <span className="text-lg font-semibold">{summary.summary.total_sangria_dias}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600 flex items-center gap-2">
              🔄 {t('mchReplacements')}
            </span>
            <span className="text-lg font-semibold">{summary.summary.total_reposicao}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600 flex items-center gap-2">
              🌧️ {t('mchTotalRain')}
            </span>
            <span className="text-lg font-semibold">{summary.summary.total_chuva_mm}mm</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyChartsView;
